import { t } from "i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import activeCustomizeIcon from "../../../../assets/images/active_customize-line.svg";
import activeToggleIcon from "../../../../assets/images/active_ion_toggle.svg";
import unActiveToggleIcon from "../../../../assets/images/ion_toggle.svg";
import unActiveCustomizeIcon from "../../../../assets/images/unactive_customize-line.svg";
import { GeneralButton } from "../../../../components";

const CustomizeButton = ({ resetSteps }: { resetSteps: () => void }) => {
  const { type, PatientId, templateId } = useParams();
  const isCustomizeTemplate = type === "customize";

  const navigate = useNavigate();
  const location = useLocation();

  const handleBack = () => {
    navigate(location.state?.from || -1);
  };

  // const methods = useFormContext()
  // const {trigger} = methods;

  return (
    <div className="mb-2 flex justify-end gap-3">
      <div className="flex gap-3">
        <GeneralButton
          icon={
            isCustomizeTemplate ? activeCustomizeIcon : unActiveCustomizeIcon
          }
          title={
            <div className="flex items-center gap-2">
              <p>{t("customize")}</p>
              <img
                src={
                  isCustomizeTemplate ? activeToggleIcon : unActiveToggleIcon
                }
                alt="customize"
              />
            </div>
          }
          color="lite"
          className={`${isCustomizeTemplate ? "" : "!text-body-text"}`}
          onClick={() => {
            // const isValid = await trigger(); 
            // if (isValid) {
            resetSteps();
            if (isCustomizeTemplate) handleBack();
            else {
              PatientId
                ? navigate(
                    `/patient/${PatientId}/medical_record/${templateId}/customize`,
                  )
                : navigate(`/medical-record-templates/${templateId}/customize`);
            }
            // }
          }}
        />
      </div>
    </div>
  );
};

export default CustomizeButton;
